export function getLogComplexId(log) {
  return String(log?.complexId?._id || log?.complexId || "");
}

function getLogTime(log) {
  const time = new Date(log?.createdAt).getTime();
  return Number.isFinite(time) ? time : 0;
}

function getIntervalSnapshot(log, fallbackSnapshot) {
  const snapshot = fallbackSnapshot || {};

  return {
    sipClientId: String(log?.sipClientId || snapshot.currentSipClientId || ""),
    clientName: log?.clientName || snapshot.currentSipClient || "",
    sip_number: log?.sip_number || snapshot.sip_number || "",
    transfer_number: log?.transfer_number ?? snapshot.transfer_number ?? "",
  };
}

export function buildClientWorkIntervals(logs) {
  const sortedLogs = [...logs].sort((left, right) => getLogTime(left) - getLogTime(right));
  const openIntervals = [];
  const intervals = [];

  function openInterval(log, snapshot) {
    const clientSnapshot = getIntervalSnapshot(log, snapshot);

    if (!clientSnapshot.clientName) {
      return;
    }

    openIntervals.push({
      sipClientId: clientSnapshot.sipClientId,
      clientName: clientSnapshot.clientName,
      sip_number: clientSnapshot.sip_number,
      transfer_number: clientSnapshot.transfer_number,
      startedAt: log.createdAt,
      startTime: getLogTime(log),
      endedAt: null,
      endTime: null,
      isOpen: true,
    });
  }

  function closeInterval(log, snapshot) {
    const clientSnapshot = getIntervalSnapshot(log, snapshot);
    const sipClientId = clientSnapshot.sipClientId;

    if (!sipClientId && !clientSnapshot.clientName) {
      return;
    }

    const index = [...openIntervals]
      .reverse()
      .findIndex((interval) => sipClientId
        ? interval.sipClientId === sipClientId
        : interval.clientName === clientSnapshot.clientName);

    if (index === -1) {
      return;
    }

    const openIndex = openIntervals.length - 1 - index;
    const interval = openIntervals.splice(openIndex, 1)[0];

    intervals.push({
      ...interval,
      sip_number: interval.sip_number || clientSnapshot.sip_number,
      transfer_number: interval.transfer_number || clientSnapshot.transfer_number,
      endedAt: log.createdAt,
      endTime: getLogTime(log),
      isOpen: false,
    });
  }

  for (const log of sortedLogs) {
    if (log.action === "client_started") {
      openInterval(log, log.nextSnapshot);
      continue;
    }

    if (log.action === "client_stopped") {
      closeInterval(log, log.previousSnapshot);
      continue;
    }

    if (log.action === "client_switched") {
      closeInterval(log, log.previousSnapshot);
      openInterval(log, log.nextSnapshot);
    }
  }

  intervals.push(...openIntervals);

  return intervals.sort((left, right) => {
    const leftTime = left.startTime || left.endTime || 0;
    const rightTime = right.startTime || right.endTime || 0;
    return rightTime - leftTime;
  });
}
